
import { Separator } from "@/components/ui/separator";

const StartupHowItWorks = () => {
  return (
    <div className="mb-16 bg-amber-50 p-8 rounded-lg">
      <div className="text-center mb-10">
        <h2 className="text-3xl font-bold mb-4">How It Works For Startups</h2>
        <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
          Our streamlined process helps you launch and scale customer acquisition through Google Ads without hiring specialists.
        </p>
      </div>
      
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-col gap-8">
          <div className="flex flex-col md:flex-row gap-6 items-start">
            <div className="md:w-1/3 flex flex-col items-center">
              <div className="w-16 h-16 rounded-full bg-amber-500 flex items-center justify-center text-white text-2xl font-bold mb-4">1</div>
              <h3 className="text-xl font-bold text-center">Set Up Your Brands</h3>
            </div>
            <div className="md:w-2/3">
              <p className="text-lg mb-2">
                Create your brand profile with your target market information and value proposition. Our platform helps you organize your campaigns effectively.
              </p>
              <div className="bg-amber-100/50 p-3 rounded-lg">
                <p className="text-sm italic">
                  "Our AI assistant is custom-trained on your specific brand's value proposition to deliver more relevant campaigns."
                </p>
              </div>
            </div>
          </div>
          
          <Separator className="bg-amber-200" />
          
          <div className="flex flex-col md:flex-row gap-6 items-start">
            <div className="md:w-1/3 flex flex-col items-center">
              <div className="w-16 h-16 rounded-full bg-amber-500 flex items-center justify-center text-white text-2xl font-bold mb-4">2</div>
              <h3 className="text-xl font-bold text-center">Create Campaigns</h3>
            </div>
            <div className="md:w-2/3">
              <p className="text-lg mb-2">
                Fill out our simple campaign creation form with your key information. Our system will generate effective campaign content tailored to your startup's needs.
              </p>
              <div className="bg-amber-100/50 p-3 rounded-lg">
                <p className="text-sm italic">
                  "Save 4+ hours per campaign with our AI-driven approach that eliminates manual keyword research and ad writing."
                </p>
              </div>
            </div>
          </div>
          
          <Separator className="bg-amber-200" />
          
          <div className="flex flex-col md:flex-row gap-6 items-start">
            <div className="md:w-1/3 flex flex-col items-center">
              <div className="w-16 h-16 rounded-full bg-amber-500 flex items-center justify-center text-white text-2xl font-bold mb-4">3</div>
              <h3 className="text-xl font-bold text-center">Review & Post</h3>
            </div>
            <div className="md:w-2/3">
              <p className="text-lg mb-2">
                Review your campaign details, including keywords and ad copy. Make any necessary adjustments before launching your campaign with a single click.
              </p>
              <div className="bg-amber-100/50 p-3 rounded-lg">
                <p className="text-sm italic">
                  "Unlike black-box solutions, you maintain complete visibility and control over your campaigns before they go live."
                </p>
              </div>
            </div>
          </div>
          
          <Separator className="bg-amber-200" />
          
          <div className="flex flex-col md:flex-row gap-6 items-start">
            <div className="md:w-1/3 flex flex-col items-center">
              <div className="w-16 h-16 rounded-full bg-amber-500 flex items-center justify-center text-white text-2xl font-bold mb-4">4</div>
              <h3 className="text-xl font-bold text-center">Get Weekly Reports</h3>
            </div>
            <div className="md:w-2/3">
              <p className="text-lg mb-2">
                Receive weekly performance reports with key metrics and insights into your campaign's effectiveness, helping you track ROI and make data-driven decisions.
              </p>
              <div className="bg-amber-100/50 p-3 rounded-lg">
                <p className="text-sm italic">
                  "Automatically generated reports compare current results to previous periods, giving you clear visibility into performance trends."
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StartupHowItWorks;
